import React from "react";
import PropTypes from "prop-types";
import lodash from "lodash";

import Employee from "./Employee";
import Modal from "../../Modal";

const Header = ({ isAdmin, isEdit, skills }) => (
  <tr>
    <th colSpan={isEdit ? 2 : null}>Employees / Skills</th>
    {isAdmin ? <th>Checked In</th> : null}
    {isAdmin ? <th>Signature</th> : null}
    {skills.map(skill => (
      <th key={skill.id} className="rotate"><div><span>{skill.name}</span></div></th>
    ))}
  </tr>
);

class TableSkills extends React.Component { 
  state = {
    openSignatureModal: false,
    signatureImage: ''
  };

  closeSignatureModal = () => {
    this.setState({openSignatureModal: false})
  }

  onOpenSignatureModal = (imageUrl) => {
    this.setState({openSignatureModal: true, signatureImage: imageUrl});
  }

  render() {
    const {
      isAdmin,
      isEdit,
      skills,
      employees,
      employeesSkills,
      inServiceUsers,
      onUpdateSkill,
      onCheckAll,
      onDelete,
      currentUser
    } = this.props;
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-white table-header-rotated">
          <thead>
          <Header isAdmin={isAdmin} isEdit={isEdit} skills={skills}/>
          </thead>
          <tbody>
          {employees.map(employee => {
            if(employee.id == currentUser.id || isAdmin)
              return(
                <Employee
                  key={employee.id}
                  isAdmin={isAdmin}
                  isEdit={isEdit}
                  employee={employee}
                  employeesSkills={employeesSkills}
                  skills={skills}
                  inServiceUser={lodash.find(inServiceUsers, { user_id: employee.id })}
                  onUpdate={onUpdateSkill}
                  onCheckAll={onCheckAll}
                  onDelete={onDelete}
                  onOpenSignatureModal={this.onOpenSignatureModal}
                />
              )
            }
          )}
          </tbody>
        </table>
        <Modal
            title="Signature"
            visible={this.state.openSignatureModal}
            onClose={this.closeSignatureModal}
          >
          <div className="signature-wrapper">
            <div className="text-center">
              <img src={this.state.signatureImage} alt="Inservice Signature" style={{maxWidth: '300px', maxHeight: '150px'}} />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
};

TableSkills.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  isEdit: PropTypes.bool.isRequired,
  skills: PropTypes.arrayOf(PropTypes.any).isRequired,
  employees: PropTypes.array.isRequired,
  employeesSkills: PropTypes.array.isRequired,
  inServiceUsers: PropTypes.array.isRequired,
  onUpdateSkill: PropTypes.func.isRequired,
  onCheckAll: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default TableSkills;
